/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Model_RoutingInputs */

const en_svchip_model_routing = /** @type {(inputs: Svchip_Model_RoutingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Model routing`)
};

const ar_svchip_model_routing = /** @type {(inputs: Svchip_Model_RoutingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`توجيه النموذج`)
};

const bn_svchip_model_routing = /** @type {(inputs: Svchip_Model_RoutingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মডেল রাউটিং`)
};

const de_svchip_model_routing = /** @type {(inputs: Svchip_Model_RoutingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modellrouting`)
};

const es_svchip_model_routing = /** @type {(inputs: Svchip_Model_RoutingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruta modelo`)
};

const fr_svchip_model_routing = /** @type {(inputs: Svchip_Model_RoutingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Routage du modèle`)
};

const pt_svchip_model_routing = /** @type {(inputs: Svchip_Model_RoutingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roteamento de modelo`)
};

const zh_svchip_model_routing = /** @type {(inputs: Svchip_Model_RoutingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`模型路由`)
};

const tr_svchip_model_routing = /** @type {(inputs: Svchip_Model_RoutingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Model yönlendirme`)
};

const ru_svchip_model_routing = /** @type {(inputs: Svchip_Model_RoutingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Маршрутизация модели`)
};

const pl_svchip_model_routing = /** @type {(inputs: Svchip_Model_RoutingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Routing modelu`)
};

/**
* | output |
* | --- |
* | "Model routing" |
*
* @param {Svchip_Model_RoutingInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_model_routing = /** @type {((inputs?: Svchip_Model_RoutingInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Model_RoutingInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_model_routing(inputs)
	if (locale === "bn") return bn_svchip_model_routing(inputs)
	if (locale === "de") return de_svchip_model_routing(inputs)
	if (locale === "es") return es_svchip_model_routing(inputs)
	if (locale === "fr") return fr_svchip_model_routing(inputs)
	if (locale === "pt") return pt_svchip_model_routing(inputs)
	if (locale === "zh") return zh_svchip_model_routing(inputs)
	if (locale === "tr") return tr_svchip_model_routing(inputs)
	if (locale === "ru") return ru_svchip_model_routing(inputs)
	if (locale === "pl") return pl_svchip_model_routing(inputs)
	return en_svchip_model_routing(inputs)
});